import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  cardIdentifierTypes: [],
  cardMaterials: [],
  cardTypes: [],
  cards: [],
  totalCards: 0,
}

export const mutations = {
  SET_CARD_IDENTIFIER_TYPES(state, cardIdentifierTypes) {
    state.cardIdentifierTypes = cardIdentifierTypes
  },
  SET_CARD_MATERIALS(state, cardMaterials) {
    state.cardMaterials = cardMaterials
  },
  SET_CARD_TYPES(state, cardTypes) {
    state.cardTypes = cardTypes
  },
  ADD_CARD_TYPE(state, cardType) {
    state.cardTypes.push(cardType)
  },
  EDIT_CARD_TYPE(state, cardType) {
    const index = state.cardTypes.findIndex(
      (item) => item.card_type_uuid === cardType.card_type_uuid
    )
    if (index !== -1) {
      state.cardTypes.splice(index, 1, cardType)
    }
  },
  DELETE_CARD_TYPE(state, card_type_uuid) {
    const index = state.cardTypes.findIndex(
      (item) => item.card_type_uuid === card_type_uuid
    )
    if (index !== -1) state.cardTypes.splice(index, 1)
  },
  SET_CARDS(state, cards) {
    state.cards = cards
  },
  SET_TOTAL_CARDS(state, totalCards) {
    state.totalCards = totalCards
  },
  ADD_CARD(state, card) {
    state.cards.push(card)
  },
  EDIT_CARD(state, card) {
    const index = state.cards.findIndex(
      (item) => item.card_uuid === card.card_uuid
    )
    if (index !== -1) {
      state.cards.splice(index, 1, card)
    }
  },
  DELETE_CARD(state, card_uuid) {
    const index = state.cards.findIndex((item) => item.card_uuid === card_uuid)
    if (index !== -1) state.cards.splice(index, 1)
  },
}

export const actions = {
  fetchCardBySerialNumber(_, payload) {
    return ApiService.fetchCardBySerialNumber(payload)
      .then((res) => {
        const card = res.data
        return card
      })
      .catch((error) => {
        throw error
      })
  },
  verifyCardSerialNumber(_, payload) {
    return ApiService.verifyCardSerialNumber(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchCardIdentifierTypes({ commit }) {
    return ApiService.fetchCardIdentifierTypes()
      .then((res) => {
        const cardIdentifierTypes = res.data.data
        commit('SET_CARD_IDENTIFIER_TYPES', cardIdentifierTypes)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchCardMaterials({ commit }) {
    return ApiService.fetchCardMaterials()
      .then((res) => {
        const cardMaterials = res.data.data
        commit('SET_CARD_MATERIALS', cardMaterials)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchCardTypes({ commit }, payload) {
    return ApiService.fetchCardTypes(payload)
      .then((res) => {
        const cardTypes = res.data.data
        commit('SET_CARD_TYPES', cardTypes)
      })
      .catch((error) => {
        throw error
      })
  },
  addCardType({ commit }, payload) {
    return ApiService.addCardType(payload)
      .then((res) => {
        const cardType = res.data
        commit('ADD_CARD_TYPE', cardType)
      })
      .catch((error) => {
        throw error
      })
  },
  editCardType({ commit }, payload) {
    return ApiService.editCardType(payload)
      .then((res) => {
        const cardType = res.data
        commit('EDIT_CARD_TYPE', cardType)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteCardType({ commit }, payload) {
    return ApiService.deleteCardType(payload)
      .then(() => {
        commit('DELETE_CARD_TYPE', payload.card_type_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchCards({ commit }, payload) {
    return ApiService.fetchCards(payload)
      .then((res) => {
        const { total, data } = res.data
        commit('SET_CARDS', data)
        commit('SET_TOTAL_CARDS', total)
      })
      .catch((error) => {
        throw error
      })
  },
  addCard({ commit }, payload) {
    return ApiService.addCard(payload)
      .then((res) => {
        const card = res.data
        commit('ADD_CARD', card)
      })
      .catch((error) => {
        throw error
      })
  },
  editCard({ commit }, payload) {
    return ApiService.editCard(payload)
      .then((res) => {
        const card = res.data
        commit('EDIT_CARD', card)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteCard({ commit }, payload) {
    return ApiService.deleteCard(payload)
      .then(() => {
        commit('DELETE_CARD', payload.card_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {}
